import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { categoryApi } from "../../../api/categoryApi";
import "./ReviewByCategoryNoScore.css";

export default function ReviewByCategoryNoScore() {
  const [categories, setCategories] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const timerRef = useRef(null);
  const navigate = useNavigate();

  const fetchCategoriesTable = useCallback(async (keyword = "") => {
    setIsLoading(true);
    setError("");
    try {
      const params = {
        pageNumber: 1,
        pageSize: 20,
        filters: {},
        isSortDesc: false,
        sortKey: "createdAt",
        seachKey: keyword,
      };
      const json = await categoryApi.getTable(params);
      const items = json?.success ? json?.data?.items ?? [] : [];
      setCategories(items);
    } catch (err) {
      setError(err?.message || "Không tải được danh sách category.");
      setCategories([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategoriesTable("");
  }, [fetchCategoriesTable]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleChangeSearch = (e) => {
    const value = e.target.value;
    setSearchKey(value);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      fetchCategoriesTable(value.trim());
    }, 300);
  };

  const handleSelectCategory = (item) => {
    navigate("/review/flashcard-no-score", {
      state: {
        id: item.id,
        name: item.name,
      },
    });
  };

  return (
    <div className="container py-4 review-no-score-category-page">
      <section className="review-no-score-hero mb-4">
        <h3 className="mb-1">Review by Category No Score</h3>
        <p className="mb-0">
          Chọn category để ôn tập nhanh tối đa 50 thẻ, không chấm điểm.
        </p>
      </section>

      <div className="review-no-score-search mb-3">
        <i className="bi bi-search"></i>
        <input
          className="form-control"
          placeholder="Tìm category..."
          value={searchKey}
          onChange={handleChangeSearch}
        />
      </div>

      {isLoading && <div className="text-muted">Đang tải category...</div>}
      {!isLoading && error && <div className="alert alert-danger py-2">{error}</div>}

      {!isLoading && !error && categories.length === 0 && (
        <div className="alert alert-info">Không có category phù hợp.</div>
      )}

      {!isLoading && !error && categories.length > 0 && (
        <div className="review-no-score-grid">
          {categories.map((item) => (
            <button
              key={item.id}
              type="button"
              className="review-no-score-card"
              onClick={() => handleSelectCategory(item)}
            >
              <div className="review-no-score-name">{item.name}</div>
              <span className="review-no-score-action">
                Open deck <i className="bi bi-arrow-right-short"></i>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
